<template>
  <div class="mk-table-box" ref="tabbox">
    <div
      @click="handleChange(item[value])"
      :class="{ 'item-tab-action': item[value] === action }"
      class="item-tab"
      v-for="item in data"
      :key="item[value]"
    >
      {{ item[label] }}{{item.count? `(${item.pre_count}+${item.count-item.pre_count || 0})` : ''}}
    </div>
  </div>
</template>

<script>
import PerfectScrollbar from 'perfect-scrollbar';
import "perfect-scrollbar/css/perfect-scrollbar.css"
export default {
  props: {
    data: {
      type: Array,
      require: true
    },
    label: {
      type: String,
      default: "label"
    },
    value: {
      type: String,
      default: "value"
    },
    action: {
      type: [Number, String]
    }
  },
  mounted() {
    this.initScroll()
  },
  methods: {
    initScroll() {
      new PerfectScrollbar(this.$refs.tabbox);
    },
    handleChange(value) {
      this.$emit('update:action', value)
      this.$emit('change', value)
    }
  }
};
</script>

<style scoped>
.mk-table-box{
  position: relative;
  display: flex;
}
.item-tab {
  color: #999;
  font-size: 12px;
  padding: 6px 12px;
  background-color: #fff;
  border-radius: 13px;
  cursor: pointer;
}
.item-tab+.item-tab{
  margin-left: 12px;
}
.item-tab-action {
  color: #3e89ff;
  font-weight: bold;
  border: 1px solid #3e89ff;
}
</style>
